export default __webpack_public_path__ + "static/media/add.0ddb797a.svg";